import type { FC, ReactNode } from 'react'

import { isNumericLabel } from '@/lib/format'

interface ReadingTimeProps {
    value: string
}

// A plain number from the CMS reads as minutes; anything else is shown exactly as written.
export const ReadingTime: FC<ReadingTimeProps> = ({ value }): ReactNode => {
    if (isNumericLabel(value)) {
        return <span>{value} min read</span>
    }

    return <span>{value}</span>
}
